// Modelo de cobrança escolhido no CRM antes de gerar o termo (#6367, pedido do Felipe Braz,
// 21/10/2026). Antes, toda UC nova nascia no modelo separado e só passava ao boleto único
// depois que o cliente aceitava no Portal — a primeira cobrança saía no formato errado.
//
// A escolha não liga o boleto único direto: "unificado" com a assinatura valendo como aceite
// vira um aceite de canal 'termo' quando o termo é assinado, e a liberação de sempre
// (liberar_boleto_unico_apos_aceite) segura quem tem débito automático na Equatorial — senão o
// cliente pagaria a conta de luz duas vezes.

export type ModeloCobranca = 'unificado' | 'separado';

export const MODELOS_COBRANCA: { valor: ModeloCobranca; titulo: string; explicacao: string }[] = [
  {
    valor: 'unificado',
    titulo: 'Boleto unificado',
    explicacao: 'Um boleto só, com a Vigor e a conta da Equatorial juntas. A Vigor paga a Equatorial pelo cliente. Quem tem débito automático na Equatorial precisa cancelá-lo antes.',
  },
  {
    valor: 'separado',
    titulo: 'Boleto Equatorial + Boleto Vigor',
    explicacao: 'Dois pagamentos: o cliente paga o boleto da Vigor e a fatura da Equatorial separadamente.',
  },
];

export interface UcModeloCobranca {
  id: number;
  empresa_parceira_id?: string | number | null;
}

/** UC de empresa parceira já nasce no boleto único (trigger da parceira): não há o que escolher. */
export const escolheModelo = (uc: UcModeloCobranca) => !uc.empresa_parceira_id;

/** UCs do termo que ainda estão sem modelo escolhido. Vazio = pode gerar o termo. */
export function ucsSemModelo(
  ucs: UcModeloCobranca[],
  escolhas: Record<number, ModeloCobranca | undefined>,
): number[] {
  return ucs.filter(escolheModelo).filter(uc => !escolhas[uc.id]).map(uc => uc.id);
}

/** A pergunta "a assinatura vale como aceite?" só faz sentido com alguma UC unificada. */
export function temUnificado(ucs: UcModeloCobranca[], escolhas: Record<number, ModeloCobranca | undefined>): boolean {
  return ucs.some(uc => escolheModelo(uc) && escolhas[uc.id] === 'unificado');
}

/** Mesmo modelo para todas as UCs do termo que têm escolha (atalho "aplicar a todas"). */
export function aplicarATodas(
  ucs: UcModeloCobranca[],
  modelo: ModeloCobranca,
  escolhas: Record<number, ModeloCobranca | undefined>,
): Record<number, ModeloCobranca | undefined> {
  const novas = { ...escolhas };
  for (const uc of ucs) if (escolheModelo(uc)) novas[uc.id] = modelo;
  return novas;
}
